import { Component, Vue, Prop } from 'vue-property-decorator'

import { StarRating } from '../StarRating';
import { IProvider } from '../../models';


const TEMED_HOST = process.env.TEMED_HOST;
const CONSULT_HOST = process.env.CONSULT_HOST;

import './PersonItem.scss';

@Component({
  template: require('./PersonItem.html'),
  components:{
    'star-rating': StarRating
  }
})
export class PersonItem extends Vue {

  @Prop()
  person: IProvider;

  get personName(){
    return this.person ? this.person.prefix + ' ' + this.person.name + ', ' + this.person.degree_credentials : null;
  }

  get personUrl(){
    return this.person ?  TEMED_HOST + this.person.url : null;
  }

  get personAvatar(){
    return this.person ? CONSULT_HOST + this.person.avatar_thumb : null;
  }
}
